import { Grid, makeStyles, Theme } from "@material-ui/core";
import { useDocumentStore } from "@roc/feature-documents";
import { CurrencyField } from "@roc/ui";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) => ({

}));

export const EditPayoffAdjustmentsForm = observer(({ }) => {
  const classes = useStyles();

  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore: { payoffAdjustmentsFormStore } },
    },
  } = useDocumentStore();

  return (
    <div>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={6}>
          <CurrencyField
            testId={'rocInterestAccrued'}
            variant={'outlined'}
            label={'Interest Adjustment'}
            standaloneLabel
            value={payoffAdjustmentsFormStore.form.fields.rocInterestAccrued.value}
            onChange={(name, value) => payoffAdjustmentsFormStore.onFieldChange('rocInterestAccrued', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
        {/* <Grid item xs={6}>
          <CurrencyField
            testId={'slsInterestAdditionalCharges'}
            variant={'outlined'}
            label={'Servicer Interest Charges'}
            standaloneLabel
            value={payoffAdjustmentsFormStore.form.fields.slsInterestAdditionalCharges.value}
            onChange={(name, value) => payoffAdjustmentsFormStore.onFieldChange('slsInterestAdditionalCharges', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid> */}
        <Grid item xs={6}>
          <CurrencyField
            testId={'rocLatePenalty'}
            variant={'outlined'}
            label={'Late Penalty Adjustment'}
            standaloneLabel
            value={payoffAdjustmentsFormStore.form.fields.rocLatePenalty.value}
            onChange={(name, value) => payoffAdjustmentsFormStore.onFieldChange('rocLatePenalty', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
        {/* <Grid item xs={6}>
          <CurrencyField
            testId={'slsPenaltyAdditionalCharges'}
            variant={'outlined'}
            label={'Servicer Late Penalty Charges'}
            standaloneLabel
            value={payoffAdjustmentsFormStore.form.fields.slsPenaltyAdditionalCharges.value}
            onChange={(name, value) => payoffAdjustmentsFormStore.onFieldChange('slsPenaltyAdditionalCharges', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid> */}
        <Grid item xs={6}>
          <CurrencyField
            testId={'defaultPenalty'}
            variant={'outlined'}
            label={'Default Penalty Adjustment'}
            standaloneLabel
            value={payoffAdjustmentsFormStore.form.fields.defaultPenalty.value}
            onChange={(name, value) => payoffAdjustmentsFormStore.onFieldChange('defaultPenalty', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
        <Grid item xs={6}>
          <CurrencyField
            testId={'defaultInterest'}
            variant={'outlined'}
            label={'Default Interest Adjustment'}
            standaloneLabel
            value={payoffAdjustmentsFormStore.form.fields.defaultInterest.value}
            onChange={(name, value) => payoffAdjustmentsFormStore.onFieldChange('defaultInterest', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
        <Grid item xs={6}>
          <CurrencyField
            testId={'maturityDefaultInterest'}
            variant={'outlined'}
            label={'Maturity Default Adjustment'}
            standaloneLabel
            value={payoffAdjustmentsFormStore.form.fields.maturityDefaultInterest.value}
            onChange={(name, value) => payoffAdjustmentsFormStore.onFieldChange('maturityDefaultInterest', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
      </Grid>
    </div>
  );
});
